import React from "react";

// Create context object for site messages
export const MessagesContext = React.createContext();

// Create context object for Cookie Service
export const CookieServiceContext = React.createContext();
